import React from 'react';

const EmptyState = ({
  title,
  description,
  icon,
  action,
  className = '',
}) => (
  <div
    className={`flex flex-col items-center rounded-ds-lg border border-dashed border-gray-300 bg-gray-50 px-ds-8 py-ds-10 text-center ${className}`.trim()}
  >
    {icon ? <div className="mb-ds-4 text-ds-brand">{icon}</div> : null}
    {title ? <div className="text-ts-lg font-fig-semibold text-gray-900">{title}</div> : null}
    {description ? <p className="mt-ds-2 max-w-md text-ts-sm text-gray-600">{description}</p> : null}
    {action ? <div className="mt-ds-6">{action}</div> : null}
  </div>
);

export default EmptyState;
